// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getLogs as listLogsAPI,
    getLog as getLogAPI,
    addLog as addLogAPI,
    updateLog as updateLogAPI,
    deleteLog as deleteLogAPI,
    getDistinctUsers as getDistinctUsersAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { logsApiResponseError, logsApiResponseSuccess } from './actions';
import { LogsActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getLog({ payload: { id } }) {
    try {
        const response = yield call(getLogAPI, id );
        const logItem = response.data.data;
        yield put(logsApiResponseSuccess(LogsActionTypes.GET_LOG, logItem));
    } catch (error) {
        yield put(logsApiResponseError(LogsActionTypes.GET_LOG, error));
    }
}

function* addLog({payload:log}){
    try{
        const response = yield call(addLogAPI,{...log})
        const logItem = response.data
        yield put(logsApiResponseSuccess(LogsActionTypes.ADD_LOG,logItem))
    } catch(error){
        yield put(logsApiResponseError(LogsActionTypes.ADD_LOG,error))
    }
}

function* updateLog({payload:log}){
    try{
        const response = yield call(updateLogAPI,{...log})
        const logItem = response.data.data
        yield put(logsApiResponseSuccess(LogsActionTypes.UPDATE_LOG,logItem))
    }catch(error){
        yield put(logsApiResponseError(LogsActionTypes.UPDATE_LOG,error))
    }
}
function* deleteLog({payload:{id}}){
    try{
        const response = yield call(deleteLogAPI,id)
        const logItem = response.data.id
        yield put(logsApiResponseSuccess(LogsActionTypes.DELETE_LOG,logItem))
    }catch(error){
        yield put(logsApiResponseError(LogsActionTypes.DELETE_LOG,error))
    }
}

/**
 * List contactos
 */
function* listLogs({payload:params}) {
    try {
        const response = yield call(listLogsAPI, {...params});
        const listaLogs = response.data.data;
        yield put(logsApiResponseSuccess(LogsActionTypes.LIST_LOGS, listaLogs));
    } catch (error) {
        yield put(logsApiResponseError(LogsActionTypes.LIST_LOGS, error));
    }
}

function* distinctUsers() {
    try {
        const response = yield call(getDistinctUsersAPI);
        const distinctUsers = response.data.data;
        yield put(logsApiResponseSuccess(LogsActionTypes.DISTINCT_USERS, distinctUsers));
    } catch (error) {
        yield put(logsApiResponseError(LogsActionTypes.DISTINCT_USERS, error));
    }
}

export function* watchGetLog(): any {
    yield takeEvery(LogsActionTypes.GET_LOG, getLog);
}

export function* watchListLogs(): any {
    yield takeEvery(LogsActionTypes.LIST_LOGS, listLogs);
}

export function* watchAddLog():any{
    yield takeEvery(LogsActionTypes.ADD_LOG,addLog)
}
export function* watchUpdateLog():any{
    yield takeEvery(LogsActionTypes.UPDATE_LOG,updateLog)
}
export function* watchDeleteLog():any{
    yield takeEvery(LogsActionTypes.DELETE_LOG,deleteLog)
}

export function* watchDistinctUsers():any{
    yield takeEvery(LogsActionTypes.DISTINCT_USERS,distinctUsers)
}


function* logsSaga(): any {
    yield all([
        fork(watchGetLog),
        fork(watchListLogs),
        fork(watchAddLog),
        fork(watchUpdateLog),
        fork(watchDeleteLog),
        fork(watchDistinctUsers)
    ]);
}

export default logsSaga;
